<template>
  <a :class="[className]" :href="href" target="_blank" @click="$emit('click')">
    <a-icon
      :width="iconWidth"
      :height="iconHeight"
      :name="iconName"
      :class="iconClass"
    />
    <slot name="title"> {{ title }}</slot>
  </a>
</template>

<script>
import AIcon from '@/components/AIcon'

export default {
  name: 'ASocialButton',
  components: { AIcon },
  emits: ['click'],
  props: {
    title: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: 'anz-link anz-btn-icon',
    },
    href: {
      type: String,
      default: '',
    },
    iconName: {
      type: String,
      default: '',
    },
    iconWidth: {
      type: String,
      default: '',
    },
    iconHeight: {
      type: String,
      default: '',
    },
    iconClass: {
      type: String,
      default: '',
    },
  },
}
</script>
